import React from 'react';
import { useNavigate } from 'react-router-dom';
import TopicCard from '../components/TopicCard';
import { useTheme } from '../contexts/ThemeContext';
import { demoArticles } from '../data/demoData';
import { CATEGORIES } from '../types';
import SEO from '../components/SEO';

export default function ArticlesPage() {
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleLike = async (articleId: string) => {
    // In a real app, this would call an API
    console.log('Liked article:', articleId);
  };

  const handleShare = async (articleId: string) => {
    const article = demoArticles.find(a => a.id === articleId);
    if (article) {
      try {
        await navigator.share({
          title: article.title,
          text: article.excerpt,
          url: `${window.location.origin}/article/${article.id}`,
        });
      } catch (err) {
        navigator.clipboard.writeText(`${window.location.origin}/article/${article.id}`);
        alert('Link copied to clipboard!');
      }
    }
  };

  return (
    <>
      <SEO
        title="Professional Articles & Industry Insights"
        description="Discover in-depth articles and analysis from industry experts. Stay informed with the latest trends, best practices, and professional insights."
        keywords={[
          'professional articles',
          'industry insights',
          'expert analysis',
          'business trends',
          'technical articles',
          'professional development',
          'industry expertise'
        ]}
        type="website"
      />

      <div className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <h1 className={`text-3xl font-bold ${
              theme === 'dark' ? 'text-gray-100' : 'text-gray-900'
            }`}>
              Articles
            </h1>
            <button
              onClick={() => navigate('/write')}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Write Article
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {demoArticles.map(article => (
              <TopicCard
                key={article.id}
                topic={{
                  ...article,
                  category: CATEGORIES.find(cat => cat.name === article.category) || CATEGORIES[0]
                }}
                onLike={() => handleLike(article.id)}
                onShare={() => handleShare(article.id)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}